//Admin Routes
import AdminDashboard from "../admin/pages/dashboard/dashboard";
import MyProfile from "../admin/pages/myprofile/MyProfile";
import CompanyProfile from "../admin/pages/companyprofile/CompanyProfile";
import TemplateBuilder from "../admin/pages/companyprofile/TemplateBuilder ";
import Subscribe from "../admin/pages/subscribe/subscribe";
import SubscribeSuccess from "../admin/pages/subscribe-success/subscribe-success";
import UserList from "../admin/pages/user/list";
import UserRoleList from "../admin/pages/userrole/list";
import UserPermissionList from "../admin/pages/userpermission/list";
import CompanyList from "../admin/pages/company/list";
import DriverList from "../admin/pages/driver/list";
import CustomerList from "../admin/pages/customer/list";
import ProductList from "../admin/pages/product/list";
import DeliveryProductList from "../admin/pages/delivery-product/list";
import AddBooking from "../admin/pages/booking/add-booking/AddBooking";
import AddDeliveryBooking from "../admin/pages/booking/add-delivery-booking/AddBooking";
import BookingList from "../admin/pages/booking/booking-list/list";
import BookingEnquery from "../admin/pages/booking/booking-list/enquiryList";
import AssignDriver from "../admin/pages/booking/assign-driver/list";
import DriverJobs from "../admin/pages/booking/driver-jobs/list";
import PickedBooking from "../admin/pages/booking/pickedupitems/list";
import ContainerList from "../admin/pages/shipping/containerList";
import ShippingList from "../admin/pages/shipping/list";
import AddShipping from "../admin/pages/shipping/add";
import DeliveryReceiveShipping from "../admin/pages/delivery/receiveShipping";
//import DeliveryAssignTodriver from "../admin/pages/delivery/assignToDriver";
import DeliveryAssignTodriver from "../admin/pages/delivery/assign-driver/list";
import DriverJobDelivery from "../admin/pages/delivery/driverJobDelivery";
import SubscriptionList from "../admin/pages/subscription/list"
import MembershipList from "../admin/pages/membership-manager/list";
import ContainerReports from "../admin/pages/reports/container-reports/ContainerReports";
import DriverReports from "../admin/pages/reports/driver-reports/DriverReports";
import OrderReports from "../admin/pages/reports/order-reports/OrderReports";
import PaymentReports from "../admin/pages/reports/payment-reports/PaymentReports";
import UserTrackingReports from "../admin/pages/reports/user-tracking-reports/UserTrackingReports";
import EmailTemplateList from "../admin/pages/email-templates/list";
import AddEmailTemplate from "../admin/pages/email-templates/add";
import PreviewEmailTemplate from "../admin/pages/email-templates/preview";

//Customer Routes
import MyBooking from "../customer/pages/mybooking/mybooking";
import CustomerBooking from "../customer/pages/add-bookings/add";
import CustomerMyProfile from "../customer/pages/myprofile/myprofile";
import UpdateProfile from "../customer/pages/updateprofile/updateprofile";
import ChangePassword from "../customer/pages/changepassword/changepassword";
import TrackBookingCustomer from "../customer/pages/track-booking/track-booking";
import ReferralHistory from "../customer/pages/referralhistories/referralhistories";

//Fontend Routes
import Home from "../fontend/pages/home/Home";
import ContactUs from "../fontend/pages/contactus/Contactus";
import Terms from "../fontend/pages/terms/terms";
import Login from "../fontend/pages/login/Login";
import Signup from "../fontend/pages/signup/Signup";
import CustomerSignup from "../fontend/pages/customer-signup/CustomerSignup";
import CustomerSignup2 from "../fontend/pages/customer-signup/CustomerSignup2";
import ForgotPassword from "../fontend/pages/forgotpassword/forgotpassword";
import ForgotPasswordcodeCheck from "../fontend/pages/forgotpasswordcodecheck/ForgotPasswordCodeCheck";
import ForgotPasswordChange from "../fontend/pages/forgotchangepassword/ForgotChangePassword";
import TrackBooking from "../fontend/pages/track-booking/track-booking";

//Driver Routes
import TodayRequestList from "../driver/pages/TodayRequestList";
import DriverAddressDetails from "../driver/pages/DriverAddressDetails";
import DriverAddressEdit from "../driver/pages/DriverAddressEdit";
import DriverItemDetails from "../driver/pages/DriverItemDetails";
import DriverItemEdit from "../driver/pages/DriverItemEdit";
import DriverPaymentDetails from "../driver/pages//DriverPaymentDetails";

const HomeRoutes = {
  path: "/",
  component: Home,
};

const ContactUsRoutes = {
  path: "/contact-us",
  component: ContactUs,
};

const TermsRoutes = {
  path: "/terms",
  component: Terms,
};

const LoginRoutes = {
  path: "/sign-in",
  component: Login,
};
const SignupRoutes = {
  path: "/sign-up",
  component: Signup,
};
const CustomerSignupRoutes = {
  path: "/customer-sign-up/:str",
  component: CustomerSignup,
};
const CustomerSignup2Routes = {
  path: "/customer-sign-up/:ctoken/:str",
  component: CustomerSignup2,
};
const ForgotpasswordRoutes = {
  path: "/forgot-password",
  component: ForgotPassword,
};
const ForgotpassworCodeCheckdRoutes = {
  path: "/forgot-password-code-check",
  component: ForgotPasswordcodeCheck,
};
const ForgotpasswordChangeRoutes = {
  path: "/forgot-password-change",
  component: ForgotPasswordChange,
};
const TrackBookingRoutes = {
  path: "/track-booking",
  component: TrackBooking,
};
export const AdminRoutes = {
  routeList: [
    {
      path: "/dashboard",
      component: AdminDashboard,
      menuName: "dashboard",
      permission: "dashboard:view",
    },
    {
      path: "/my-profile",
      component: MyProfile,
      menuName: "myprofile",
      permission: "all:read",
    },
    {
      path: "/company-profile",
      component: CompanyProfile,
      menuName: "companyprofile",
      permission: "all:read",
    },
    {
      path: "/company-template",
      component: TemplateBuilder,
      menuName: "TemplateBuilder",
      permission: "all:read",
    },
    {
      path: "/subscribe",
      component: Subscribe,
      menuName: "subscribe",
      permission: "all:read",
    },
    {
      path: "/subscribe-success",
      component: SubscribeSuccess,
      menuName: "subscribe-success",
      permission: "all:read",
    },
    {
      path: "/customer/list",
      component: CustomerList,
      menuName: "customer",
      permission: "customers:list",
    },
    {
      path: "/user/list",
      component: UserList,
      menuName: "settings",
      permission: "settings:user-list",
    },
    {
      path: "/user-role/list",
      component: UserRoleList,
      menuName: "settings",
      permission: "settings:user-role-list",
    },
    {
      path: "/user-permissions",
      component: UserPermissionList,
      menuName: "settings",
      permission: "settings:user-permission",
    },
    {
      path: "/driver/list",
      component: DriverList,
      menuName: "driver",
      permission: "drivers:list",
    },
    {
      path: "/product/list",
      component: ProductList,
      menuName: "items",
      permission: "items:list",
    },
    {
      path: "/delivery-product/list",
      component: DeliveryProductList,
      menuName: "items",
      permission: "items:list",
    },
    {
      path: "/company/list",
      component: CompanyList,
      menuName: "settings",
      permission: "",
    },
    {
      path: "/booking/add-booking",
      component: AddBooking,
      menuName: "booking",
      permission: "bookings:create",
    },
    {
      path: "/booking/edit-booking/:booking_id",
      component: AddBooking,
      menuName: "booking",
      permission: "bookings:update",
    },
    {
      path: "/booking/add-delivery-booking",
      component: AddDeliveryBooking,
      menuName: "booking",
      permission: "bookings:create",
    },
    {
      path: "/booking/edit-delivery-booking/:booking_id",
      component: AddDeliveryBooking,
      menuName: "booking",
      permission: "bookings:update",
    },
    {
      path: "/booking/list",
      component: BookingList,
      menuName: "booking",
      permission: "bookings:list",
    },
    {
      path: "/booking/enquery/:bookingId",
      component: BookingEnquery,
      menuName: "booking",
      permission: "bookings:list",
    },
    {
      path: "/booking/assign-drivers",
      component: AssignDriver,
      menuName: "booking",
      permission: "bookings:assign-driver",
    },
    {
      path: "/booking/driver-jobs",
      component: DriverJobs,
      menuName: "booking",
      permission: "bookings:driver-jobs",
    },
    {
      path: "/booking/picked-items",
      component: PickedBooking,
      menuName: "booking",
      permission: "bookings:picked-items",
    },
    {
      path: "/shipping/container-list",
      component: ContainerList,
      menuName: "shipping",
      permission: "shipping:container-list",
    },
    {
      path: "/shipping/list",
      component: ShippingList,
      menuName: "shipping",
      permission: "shipping:list",
    },
    {
      path: "/shipping/add",
      component: AddShipping,
      menuName: "shipping",
      permission: "shipping:add",
    },
    {
      path: "/shipping/view/:shippingId",
      component: AddShipping,
      menuName: "shipping",
      permission: "shipping:update",
    },
    {
      path: "/delivery/receive-shipping",
      component: DeliveryReceiveShipping,
      menuName: "delivery",
      permission: "delivery:receive-shipping",
    },
    {
      path: "/delivery/assign-to-driver",
      component: DeliveryAssignTodriver,
      menuName: "delivery",
      permission: "delivery:assign-driver",
    },
    {
      path: "/delivery/driver-jobs",
      component: DriverJobDelivery,
      menuName: "delivery",
      permission: "delivery:driver-jobs",
    },
    {
      path: "/subscription/list",
      component: SubscriptionList,
      menuName: "subscription",
      permission: "subscription:read",
    },
    {
      path: "/membership/list",
      component: MembershipList,
      menuName: "membership",
      permission: "settings:membership-list",
    },
    {
      path: "/report/driver-report",
      component: DriverReports,
      menuName: "report",
      permission: "report:driver-report",
    },
    {
      path: "/report/container-report",
      component: ContainerReports,
      menuName: "report",
      permission: "report:container-report",
    },
    {
      path: "/report/customer-orders",
      component: OrderReports,
      menuName: "report",
      permission: "report:customer-orders",
    },
    {
      path: "/report/payment-report",
      component: PaymentReports,
      menuName: "report",
      permission: "report:payment-report",
    },
    {
      path: "/report/user-tracking-report",
      component: UserTrackingReports,
      menuName: "report",
      permission: "report:user-tracking-report",
    },
    {
      path: "/email-template/list",
      component: EmailTemplateList,
      menuName: "settings",
      permission: "",
    },
    {
      path: "/email-template/add",
      component: AddEmailTemplate,
      menuName: "settings",
      permission: "",
    },
    {
      path: "/email-template/edit/:templateId",
      component: AddEmailTemplate,
      menuName: "settings",
      permission: "",
    },
    {
      path: "/email-template/preview/:templateId",
      component: PreviewEmailTemplate,
      menuName: "settings",
      permission: "",
    },
  ],
};
export const FrontRouteList = [HomeRoutes, ContactUsRoutes, TermsRoutes, TrackBookingRoutes];

export const DriverRoutes = {
  routeList: [
    {
      path: "/today-request-list",
      component: TodayRequestList,
    },
    {
      path: "/address-details/:id",
      component: DriverAddressDetails,
    },
    {
      path: "/address-edit/:id",
      component: DriverAddressEdit,
    },
    {
      path: "/item-details/:id",
      component: DriverItemDetails,
    },
    {
      path: "/item-edit/:id",
      component: DriverItemEdit,
    },
    {
      path: "/payment-details/:id",
      component: DriverPaymentDetails,
    },
  ],
};
export const CustomerRoutes = {
  routeList: [
    {
      path: "/my-bookings",
      component: MyBooking,
    },
    {
      path: "/add-booking",
      component: CustomerBooking,
    },
    {
      path: "/profile",
      component: CustomerMyProfile,
    },
    {
      path: "/update-profile",
      component: UpdateProfile,
    },
    {
      path: "/change-password",
      component: ChangePassword,
    },
    {
      path: "/track-booking",
      component: TrackBookingCustomer,
    },
    {
      path: "/referral-histories",
      component: ReferralHistory,
    },
  ],
};

export const WithoutThemeRouteList = [
  LoginRoutes,
  ForgotpasswordRoutes,
  ForgotpassworCodeCheckdRoutes,
  ForgotpasswordChangeRoutes,
  SignupRoutes,
  CustomerSignupRoutes,
  CustomerSignup2Routes
];